<template>
    <HelpListPage
        id="HELP_PAGE_EDITING"
        :heading="$t('helpPage.editPage.heading')"
        :title="$t('helpPage.editPage.title')"
        :description="$t('helpPage.editPage.description')"
    />
</template>

<script>
import HelpListPage from '../../components/help/helpListPage';
import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'

export default {
    components: {
        HelpListPage
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));
    }
}
</script>
